import {
  Assessment,
  ComprehensiveAssessment,
  Event,
  Fixture,
  ICCReview,
  Org,
  Player,
  Team,
  Tournament,
  User,
  Venue,
} from 'src/api';
import { MainMenuOption } from 'src/service/MainMenu';
import { AbstractUserRole } from 'src/service/UserPermission/AbstractUserRole';

export class AdminRole extends AbstractUserRole {
   
  canView(option: MainMenuOption): boolean {
    return true;
  }
   
  canSeeCompletedTournaments(): boolean {
    return true;
  }
  // unions
   
  canViewUnion(union: Org): boolean {
    return true;
  }

   
  canEditUnion(union: Org): boolean {
    return true;
  }

  // teams
   
  canViewTeam(team: Team): boolean {
    return true;
  }

   
  canEditTeam(team: Team): boolean {
    return true;
  }

  // players
   
  canViewPlayer(player: Player): boolean {
    return true;
  }

   
  canEditPlayer(player: Player): boolean {
    return true;
  }

  // events
   
  canCommentEvent(event: Event): boolean {
    return true;
  }

   
  canEditEvent(event: Event): boolean {
    return true;
  }

   
  canReviewEvent(event: Event): boolean {
    return true;
  }

  // comprehensives
   
  canCreateComprehensiveAssessment(player: Player): boolean {
    return true;
  }

   
  canViewComprehensiveAssessment(assessment: ComprehensiveAssessment): boolean {
    return true;
  }

   
  canReviewComprehensiveAssessment(assessment: ComprehensiveAssessment): boolean {
    return true;
  }

   
  canEditComprehensiveAssessment(assessment: ComprehensiveAssessment): boolean {
    return true;
  }

  // assessments
   
  canViewAssessment(assessment: Assessment): boolean {
    return true;
  }

  // users
   
  canViewUser(user: User): boolean {
    return true;
  }

   
  canEditUser(user: User): boolean {
    return true;
  }

  // tournaments
   
  canViewTournament(tournament: Tournament): boolean {
    return true;
  }

   
  canEditTournament(tournament: Tournament): boolean {
    return true;
  }

  // venues
   
  canViewVenue(venue: Venue): boolean {
    return true;
  }

   
  canEditVenue(venue: Venue): boolean {
    return true;
  }

  // fixtures
   
  canAddFixture(tournament: Tournament | undefined): boolean {
    return true;
  }

   
  canViewFixture(fixture: Fixture): boolean {
    return true;
  }

   
  canEditFixture(fixture: Fixture): boolean {
    return true;
  }

   
  canAddMDDToFixture(fixture: Fixture): boolean {
    return true;
  }

  // icc reviews
   
  canViewICCReview(review: ICCReview): boolean {
    return true;
  }

   
  canEditICCReview(review: ICCReview): boolean {
    return true;
  }

  canToggleICCCompliance(): boolean {
    return true;
  }

  canIgnoreEvents(): boolean {
    return true;
  }
}
